import request from '@/config/axios'

// 丢单原因分类 VO
export interface LostReasonVO {
  id: number // 编号
  name: string // 概述名称（列表「摘要」列）
  remark: string // 备注
  creator?: string
  createTime?: Date
}

// 丢单原因分类 API
export const LostReasonApi = {
  // 查询丢单原因分类分页
  getLostReasonPage: async (params: any) => {
    return await request.get({ url: `/crm/lost-reason/page`, params })
  },

  // 查询全部丢单原因分类（用于「丢单分析」表单下拉）
  getLostReasonListAll: async () => {
    return await request.get({ url: `/crm/lost-reason/list-all` })
  },

  // 查询丢单原因分类详情
  getLostReason: async (id: number) => {
    return await request.get({ url: `/crm/lost-reason/get?id=` + id })
  },

  // 新增丢单原因分类
  createLostReason: async (data: LostReasonVO) => {
    return await request.post({ url: `/crm/lost-reason/create`, data })
  },

  // 修改丢单原因分类
  updateLostReason: async (data: LostReasonVO) => {
    return await request.put({ url: `/crm/lost-reason/update`, data })
  },

  // 删除丢单原因分类
  deleteLostReason: async (id: number) => {
    return await request.delete({ url: `/crm/lost-reason/delete?id=` + id })
  },

  // 导出丢单原因分类
  exportLostReason: async (params: any) => {
    return await request.download({ url: `/crm/lost-reason/export`, params })
  }
}
